import { Button, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import { withTranslation } from "react-i18next";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { bulkDelete } from "store/bulk/action";
import { ApplicationState } from "store";

const DeleteModal = ({ t, show, onCloseClick, selectedIds, setTriggerApi, model, setSelectedIds, setCheckedRows}: any) => {
    const dispatch: ThunkDispatch<any, null, Action<string>> = useDispatch();
    const loading = useSelector((state: ApplicationState) => state.bulk.loading);
    const onBulkDelete = () => {
        const handleSuccess = (body: any) => {
            setTriggerApi((triggerApi: boolean) => !triggerApi)
            onCloseClick()
            setSelectedIds([])
            setCheckedRows({})
        }
        const handleFailure = (body: any) => {
            onCloseClick()
        }
        dispatch(bulkDelete(model, selectedIds, handleSuccess, handleFailure))
    }

    return (
        <Modal backdrop="static" isOpen={show} toggle={onCloseClick} centered={true}>
            <ModalHeader className="p-3 offcanvas-header-dark d-flex flex-row justify-content-between align-items-center bg-primary" toggle={onCloseClick}>
                <span className='text-light'>{t(`common.table.delete`)} {selectedIds?.length} {t(`common.modals.records`)}</span>
            </ModalHeader>
            <ModalBody className='text-center p-5'>
                <div className="mt-1">
                    <i className="ri-delete-bin-5-line display-5 text-danger"></i>
                    <p className="text-muted fs-15 mb-4">{t("properties.delete_disclaimer1")} {t("properties.delete_disclaimer2")}</p>
                    <div className="hstack gap-2 justify-content-center">
                        <Button className="btn btn-danger" onClick={() => onBulkDelete()} disabled={loading}>
                        {loading ? <Spinner size="sm" type="grow" className="flex-shrink-0" role="status"> {t("common.table.loading")} </Spinner>: null }{" "}                   
                            {t("properties.delete")}
                        </Button>
                        <Button color="danger" onClick={() => onCloseClick()} outline>
                            {t("common.offcanvas.import_cancel")}
                        </Button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    ) as unknown as JSX.Element;
};

export default withTranslation()(DeleteModal);